import React from 'react';
import PropTypes from 'prop-types';
import filterProps from './filter-props';

/**
 * A simple text holder.
 *
 * @param {object} props props
 * @returns {HTMLElement} The text
 */
export default function Text({
  inline,
  ...props
}) {
  return inline ?
    <span { ...filterProps('span', props) } /> :
    <p { ...filterProps('p', props) } />;
}

Text.propTypes = {
  /** Value indicating if this should be a non-wrapping span. */
  inline: PropTypes.bool
};

Text.defaultProps = {
  inline: false
};
